module.exports = __webpack_public_path__ + "static/media/superhero.fe7456f5.png";